import React, { useState, useEffect } from "react";
import axios from "axios";
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function EqpPoList(){

  const [pharmviewData, setpharmviewData] = useState([]);

  useEffect(() => {
    fetchpharmviewData();
  }, []);

    function fetchpharmviewData() {
    axios.get(`${baseUrl}add-eqp-grn/`)
      .then(response => {
        const transformedData = response.data.map(item => ({
          ...item,
          supp: item.supp?.name || '', // Extract distributor name
          action: (
            <Link target="_blank" to={`/eqp-grn-invoice/${item.grn_no}/`} className="btn btn-success">
              View
            </Link>
          )
        }));
        setpharmviewData(transformedData);
      })
      .catch(error => {
        console.log(error);
      });
  }

    const columns = [
        {field:'id', headerName:'ID',width: 80},
         {
    field: 'grn_no',
    headerName: 'PO No',
    width: 150,
    renderCell: (params) => params.value.replace('EQGRN-', 'PO-'),
  },
        {
          field: 'product',
          headerName: 'Product',
          width: 290,
          renderCell: (params) => params.row.product,
        },
        {
          field: 'supp',
          headerName: 'Supplier',
          width: 220,
          renderCell: (params) => params.row.supp.name,
        },
        {
          field: 'grnamount',
          headerName: 'PO Amount',
          width: 90,
          renderCell: (params) => params.row.grnamount,
        },
        {
          field: 'grn_date',
          headerName: 'PO Date',
          width: 100,
          renderCell: (params) => params.row.grn_date,
        },
        {
          field: 'action',
          headerName: 'Action',
          width: 80,
          renderCell: (params) => (
            <Link target="_blank" to={`/eqp-po-invoice/${params.row.grn_no}/`} className="btn btn-success">
              View
            </Link>
          ),
          sortable: false,
          filterable: false,
          disableColumnMenu: true,
        },

      ];
    return (
    <section className="container mt-4">
    <div className="row">
    <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef' }}>
          <i className="fa-solid fa-list" aria-hidden="true" style={{ color: 'red' }}></i>
         Equipment PO List
    </h3>
    {pharmviewData.length > 0 ? (
        <div style={{ height: '100%', width: '100%' }} className="mt-4">
            <DataGrid
            sx={{
            boxShadow: 4,
            border: 4,
            borderColor: 'primary.light',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            }}
            rows= {pharmviewData}
            columns= {columns}
            pageSize= {10}
             slots={{
              toolbar: GridToolbar,
              Pagination: GridPagination,
              }}
            autoHeight
            initialState={{
                sorting: {
                  sortModel: [{ field: 'id', sort: 'desc' }],
                },
              }}
            />
        </div>
    ) : (
      <></>
    )}
    </div>
    </section>
    )
}

export default EqpPoList;
